// extracted by mini-css-extract-plugin
export default {"grid":"Homepage_grid__4nhWE","logo":"Homepage_logo__JiM29"};